import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ServiceDetail from "@/pages/ServiceDetail";
import Sectors from "@/pages/Sectors";
import SectorDetail from "@/pages/SectorDetail";
import CaseStudies from "@/pages/CaseStudies";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import ProjectBrief from "@/pages/ProjectBrief";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ClientLogin from "@/pages/ClientLogin";
import ClientLayout from "@/pages/portal/ClientLayout";
import ClientDashboard from "@/pages/portal/ClientDashboard";
import ClientProjects from "@/pages/portal/ClientProjects";
import ClientProjectDetail from "@/pages/portal/ClientProjectDetail";
import ClientInvoices from "@/pages/portal/ClientInvoices";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/services/:slug" element={<ServiceDetail />} />
              <Route path="/secteurs" element={<Sectors />} />
              <Route path="/secteurs/:slug" element={<SectorDetail />} />
              <Route path="/realisations" element={<CaseStudies />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/a-propos" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/cahier-des-charges" element={<ProjectBrief />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/portail/login" element={<ClientLogin />} />
            <Route path="/portail" element={<ClientLayout />}>
              <Route index element={<ClientDashboard />} />
              <Route path="projets" element={<ClientProjects />} />
              <Route path="projets/:id" element={<ClientProjectDetail />} />
              <Route path="factures" element={<ClientInvoices />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
